import { yupResolver } from '@hookform/resolvers/yup';
import { DeepPartial, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { errorsInput } from 'src/consts';
import { OrganizationTimeSlot } from 'src/features/DeliveryPublicColiInfo/delivery-public-colis-info.types';
import { isValidPhone } from 'src/helpers';
import * as Yup from 'yup';

type CustomerDeliveryRequestPayload = {
  fullName: string;
  email: string;
  name: string;
  tel: string;
  address: string;
  city: string;
  zipCode: string;
  optin: boolean;
  lat: number;
  long: number;
  deliveryTimeSlot: OrganizationTimeSlot[];
  promoCode?: string;
};

type Props = {
  defaultValues: DeepPartial<CustomerDeliveryRequestPayload>;
};

const timeSlotSchema = Yup.object().shape({
  from: Yup.string().required(),
  to: Yup.string().required(),
});

const deliveryTimeSlotDayConfigSchema = Yup.object().shape({
  day: Yup.string().required(),
  slots: Yup.array().of(timeSlotSchema).required(),
});

export const useCustomerDeliveryRequest = ({ defaultValues }: Props) => {
  const { t } = useTranslation();
  const validationSchema = Yup.object().shape({
    email: Yup.string().required(errorsInput.required).email(t(errorsInput.emailInvalidFormat)),
    tel: Yup.string()
      .required(errorsInput.required)
      .test('phone-rule', t(errorsInput.phoneInvalid), (value) => {
        return isValidPhone(`+${value}`);
      }),
    promoCode: Yup.string().optional(),
    optin: Yup.boolean().oneOf([true], errorsInput.required).required(errorsInput.required),
    zipCode: Yup.string().required(errorsInput.required),
    city: Yup.string().required(errorsInput.required),
    address: Yup.string().required(errorsInput.required),
    deliveryTimeSlot: Yup.array().of(deliveryTimeSlotDayConfigSchema).required(),
  });

  const formOptions = { resolver: yupResolver(validationSchema), defaultValues };

  const {
    handleSubmit,
    control,
    reset,
    setValue,
    formState: { errors },
  } = useForm<CustomerDeliveryRequestPayload>(formOptions);
  return {
    errors,
    handleSubmit,
    reset,
    setValue,
    control,
  };
};
